import { useEffect } from 'react'
import { addListener } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { PATIENT_CHART_PAGE_PATH } from '../../../utils/constants'
import {
  SAVE_VISIT_NOTES_SUCCESS,
  SAVE_VISIT_PATIENT_INSTRUCTIONS_SUCCESS,
  COMPLETE_VISIT_CALL_SUCCESS,
  DELETE_VISIT_NOTES_SUCCESS,
  DELETE_VISIT_PATIENT_INSTRUCTIONS_SUCCESS,
} from '../../../store/waitingRoom/WaitingRoomConstants'
import {
  COMPLETE_VISIT_SUCCESS,
  SAVE_PATIENT_INSTRUCTIONS_ADDENDUM_SUCCESS,
  SAVE_VISIT_NOTES_ADDENDUM_SUCCESS,
  UNRESOLVE_VISIT_SUCCESS,
  UPDATE_ICD_CODES_SUCCESS,
} from '../../../store/charts/ChartsConstants'
import { getTabId } from '../../../utils/common'
import { getPastVisitInfo } from '../../../store/charts/ChartsThunk'
import {
  setIsNoteAddendumSuccessfullyAdded,
  setIsPatientInstructionsAddendumSuccessfullyAdded,
  setPatientInstruction,
  setUpcomingVisitNote,
} from '../../../store/charts/ChartsActions'
import { GET_PRODUCTS, GET_PRODUCTS_ERROR, GET_PRODUCTS_SUCCESS } from '../../../store/products/productsConstants.ts'

export const PastVisitNotesListener = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  patientId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onSetVisitNoteLocalValue,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onSetPatientInstructionsLocalValue,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setNotesAddendumText,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setIsNotesAddendumPressed,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setPatientInstructionsAddendumText,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setIsPatientInstructionsAddendumPressed,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setIsResetEditModeIcdCodes,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setEndedVisitId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setIsLoading,
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    const unsubscribe = dispatch(
      addListener({
        predicate: () => true,
        effect: async (action, listenerApi) => {
          const currentTabId = getTabId()

          switch (action.type) {
            case GET_PRODUCTS:
              setIsLoading(true)
              break
            case GET_PRODUCTS_SUCCESS:
            case GET_PRODUCTS_ERROR:
              setIsLoading(false)
              break
            case SAVE_VISIT_NOTES_SUCCESS:
            case DELETE_VISIT_NOTES_SUCCESS:
              if (visitId === action.extraData.visitId) {
                const isNoteDeleted = action.type === DELETE_VISIT_NOTES_SUCCESS
                setIsNotesAddendumPressed(false)
                onSetVisitNoteLocalValue(action.extraData.Notes || '', true)
                dispatch(setUpcomingVisitNote(visitId, isNoteDeleted ? null : action.payload))
              }
              break
            case SAVE_VISIT_PATIENT_INSTRUCTIONS_SUCCESS:
            case DELETE_VISIT_PATIENT_INSTRUCTIONS_SUCCESS:
              if (visitId === action.extraData.visitId) {
                const isInstrutionDeleted = action.type === DELETE_VISIT_PATIENT_INSTRUCTIONS_SUCCESS
                setIsPatientInstructionsAddendumPressed(false)
                onSetPatientInstructionsLocalValue(action.extraData.PatientInstructions || '', true)
                dispatch(setPatientInstruction(visitId, isInstrutionDeleted ? null : action.payload))
              }
              break
            case COMPLETE_VISIT_SUCCESS:
            case UNRESOLVE_VISIT_SUCCESS:
              if (currentTabId === action.extraData.tabId) {
                navigate(`${PATIENT_CHART_PAGE_PATH}?id=${patientId}`)
              } else if (visitId === action.extraData.visitId) {
                // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
                listenerApi.dispatch(getPastVisitInfo({ visitId, isSilence: true }))
              }
              break
            case SAVE_VISIT_NOTES_ADDENDUM_SUCCESS:
              if (currentTabId === action.extraData.tabId) {
                setNotesAddendumText('')
                setIsNotesAddendumPressed(false)
                setTimeout(() => {
                  listenerApi.dispatch(setIsNoteAddendumSuccessfullyAdded(false, visitId))
                }, 300)
              }
              break
            case SAVE_PATIENT_INSTRUCTIONS_ADDENDUM_SUCCESS:
              if (currentTabId === action.extraData.tabId) {
                setPatientInstructionsAddendumText('')
                setIsPatientInstructionsAddendumPressed(false)
                setTimeout(() => {
                  listenerApi.dispatch(setIsPatientInstructionsAddendumSuccessfullyAdded(false, visitId))
                }, 300)
              }
              break
            case UPDATE_ICD_CODES_SUCCESS:
              if (currentTabId === action.extraData.tabId) {
                setIsResetEditModeIcdCodes(true)
              }
              break
            case COMPLETE_VISIT_CALL_SUCCESS:
              setEndedVisitId(action.extraData.visitId)
              break
            default:
              break
          }
        },
      }),
    )
    // @ts-expect-error TS2349 -- MIGRATION: not approved, fix when encountered
    return () => unsubscribe()
  }, [])

  return null
}
